export default __webpack_public_path__ + "static/media/Show.25eddb55.svg";